<div class="menu-icon-wrapper" rtl2HoverClass="color-hover" (click)="toggleMenu()">
  <mat-icon>account_circle</mat-icon>
</div>

<div class="menu-icon-wrapper" rtl2HoverClass="color-hover" (click)="logout()">
  <span>{{ 'header-menu.logout' | translate }}</span>
</div>

<prp-user-profile [@slideInOut]="(userprofile$ | async) || 'out'"></prp-user-profile>
